import React from 'react';
import PropTypes from 'prop-types';
import LazyLoadImg from '../../widgets/shared/LazyLoadImg';

import { sizedImageShape } from '../../../types';

const FeaturedCard = ({ altText, link, title, thumbnailImage }) => {
  const hasImage = thumbnailImage && thumbnailImage.url;

  return (
    <div className="card featured">
      <div className="content">
        <a href={link} title={`Link to ${title}`}>
          <div className={`inner-image${thumbnailImage ? '' : ' no-thumbnail'}`}>
            {hasImage && <LazyLoadImg src={thumbnailImage} alt={altText || `${title} thumbnail`} />}
          </div>
          <div className="inner-content">
            <p className="title">{title}</p>
            <span className="section-header link">Read more</span>
          </div>
        </a>
      </div>
    </div>
  );
};

FeaturedCard.defaultProps = {
  altText: '',
  thumbnailImage: ''
};

FeaturedCard.propTypes = {
  altText: PropTypes.string,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnailImage: sizedImageShape
};

export default FeaturedCard;
